import { companyApiRoute } from '@crm/shared/api'

export const addNewDealApiRoutes = {
  createDealRoute: () => companyApiRoute('crm/deal'),
}
